import { render, staticRenderFns } from "./AddNewOpenWallet.vue?vue&type=template&id=0334df40"
import script from "./AddNewOpenWallet.vue?vue&type=script&lang=js"
export * from "./AddNewOpenWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports